import querystring from 'query-string';

export default function getUTM(): Record<
  string,
  string | (string | null)[] | null
> {
  const {
    fbclid,
    gclid,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    utm_term,
  } = querystring.parse(window.location.search);

  return {
    fbclid,
    gclid,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    utm_term,
  };
}
